var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.viewer, {
    tag: "component",
    attrs: {
      response: _vm.response,
      layer: _vm.layer,
      activeItemId: _vm.activeItemId,
    },
    on: { close: _vm.onCloseViewer },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }